import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from "../plugins/axios";

Vue.use(VueRouter);

const routes = [
    {
        // 관리자 메인
        path: '/certification',
        component: () => import('../pages/client/Certification.vue'),
        props: true,
    },

    {
        path: '/plugins/kcp/cert/request',
        component: () => import('../pages/plugins/kcp/KCPCertRequest.vue'),
        props: true
    },
    {
        path: '/plugins/kcp/cert/response',
        component: () => import('../pages/plugins/kcp/KCPCertResponse.vue'),
        props: true
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 관리자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 관리자 메인
        path: '/console',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/Main.vue'),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 대시보드
        path: '/console/dashboard',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/Dashboard.vue'),
        props: true
    },
    
    {
        // 관리자 - 목록
        path: '/console/admins',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/admin/AdminList.vue'),
        props: true
    },
    {
        // 관리자 - 생성
        path: '/console/admins/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/admin/AdminView.vue'),
        props: true
    },
    {
        // 관리자 - 상세
        path: '/console/admins/:_admin',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/admin/AdminView.vue'),
        props: true
    },

    {
        // 관리자 - 회원등급
        path: '/console/partners',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/partner/PartnerList.vue'),
        props: true
    },
    {
        // 관리자 - 회원등급
        path: '/console/partners/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/partner/PartnerView.vue'),
        props: true
    },
    {
        // 관리자 - 회원등급
        path: '/console/partners/:_partner',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/partner/PartnerView.vue'),
        props: true
    },

    {
        // cp - 리스트
        path: '/console/cps',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/cp/CpList.vue'),
        props: true
    },
    {
        // cp - 캐시 내역
        path: '/console/cps/cashes',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/cp/cash/CashList.vue'),
        props: true
    },
    {
        // cp - 생성
        path: '/console/cps/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/cp/CpView.vue'),
        props: true
    },
    {
        // cp - 수정
        path: '/console/cps/:_cp',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/cp/CpView.vue'),
        props: true
    },
    {
        // cp - 주문 리스트
        path: '/console/cps/shop/orders',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/cp/shop/orders/CpOrderList.vue'),
        props: true
    },
    {
        // cp - 주문상세
        path: '/console/cps/shop/orders/:_order',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/cp/shop/orders/CpOrderView.vue'),
        props: true
    },
    {
        // 관리자 - 회원등급
        path: '/console/cashes',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/cashes/CashList.vue'),
        props: true
    },
    {
        // 관리자 - 회원등급
        path: '/console/members/withdrawals',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/member/WithdrawalList.vue'),
        props: true
    },
    {
        // 관리자 - 회원등급
        path: '/console/members/levels',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/member/LevelList.vue'),
        props: true
    },
    {
        // 관리자 - 사용자 정보
        path: '/console/members',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/member/MemberList.vue'),
        props: true
    },
    {
        // 관리자 - 사용자 정보
        path: '/console/members/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/member/MemberView.vue'),
        props: true
    },
    {
        // 관리자 - 사용자 정보
        path: '/console/members/:_member',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/member/MemberView.vue'),
        props: true
    },
    {
        // 관리자 - 상품관리
        path: "/console/shop/giftcards",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/GiftcardList.vue"),
        props: true,
    },
    {
        // 관리자 - 상품 생성
        path: "/console/shop/giftcards/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/GiftcardView.vue"),
        props: true,
    },
    {
        // 관리자 - 상품 복사
        path: "/console/shop/giftcards/copy",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/GiftcardView.vue"),
        props: true,
    },
    {
        // 관리자 - 상품 view
        path: "/console/shop/giftcards/:_giftcard",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/GiftcardView.vue"),
        props: true,
    },
    {
        // 관리자 - 주문목록(수동)
        path: "/console/shop/orders/manual",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ManualOrderList.vue"),
        props: true,
    },
    {
        // 관리자 - 주문상세(수동)
        path: "/console/shop/orders/manual/:_order",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ManualOrderView.vue"),
        props: true,
    },
    {
        // 관리자 - 주문목록(api)
        path: "/console/shop/orders/api",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ApiOrderList.vue"),
        props: true,
    },
    {
        // 관리자 - 주문상세(api)
        path: "/console/shop/orders/api/:_order",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ApiOrderView.vue"),
        props: true,
    },
    {
        // 관리자 - 주문목록
        path: "/console/shop/orders",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/OrderList.vue"),
        props: true,
    },
    {
        // 관리자 - 주문상세
        path: "/console/shop/orders/:_order",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/OrderView.vue"),
        props: true,
    },
    {
        // 관리자 - 카테고리 관리
        path: "/console/shop/brands",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/BrandList.vue"),
        props: true,
    },
    {
        // 관리자 - 카테고리 관리
        path: "/console/shop/categories",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/CategoryList.vue"),
        props: true,
    },
    {
        // 관리자 - 서비스 이용약관
        path: '/console/terms',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/terms/TermsList.vue'),
        props: true
    },
    {
        // 관리자 - 팝업관리
        path: '/console/setting',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/setting/SettingView.vue'),
        props: true
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {

    let accessToken = sessionStorage.getItem("accessToken");
    
    axios.defaults.headers.common['Authorization'] = accessToken ? `Bearer ${accessToken}` : "";

    next();
});

export default router
